import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { NewSearchResultModel } from '@app/services/new-search.service';
import { environment } from '@env/environment';
import { NgFor, NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { SafeHtmlPipe } from '@app/shared/pipes/safe-html.pipe';

@Component({
    selector: 'new-search-result',
    templateUrl: './new-search-result.component.html',
    styleUrls: ['./new-search-result.component.css'],
    imports: [NgFor, NgIf, SafeHtmlPipe]
})
export class NewSearchResultComponent implements OnInit {

  constructor(private router: Router) {}

  @Input() listing: NewSearchResultModel;
  activityIconPath = 'assets/images/icons/Activity';

  public imageUrl?: string;
  public listingOfferDsc: boolean = true;
  public maxDescriptionLength: number = 100;
  public currentImageIndex = 0;

  ngOnInit(): void {
    if (this.listing.images.length > 0) {
      this.imageUrl = environment.apiUrl + this.listing.images[0].thumbnailUrl;
    }
  }

  formatImageUrl(image: any): string {
    if (!image || !image.thumbnailUrl) {
      return 'assets/images/placeholder.jpg';
    }
    return environment.apiUrl + image.thumbnailUrl;
  }

  public get offerDesc(): string {
    if (!this || this.listing == undefined || !this.listing.description) {
      return '';
    }
    if (this.listing.description.length > this.maxDescriptionLength) {
      return this.listing.description.substring(0, this.maxDescriptionLength) + '...';
    } else {
      return this.listing.description;
    }
  }

  formatActivityImg(activities: any): string {
    return `${this.activityIconPath}/${activities.activityIcon}`;
  }

  onCardClick(): void {
    this.router.navigate(['/listing', this.listing.listingId]);
  }

  onMouseEnter(): void {
    // No longer setting cardHovered
  }

  onMouseLeave(): void {
    // No longer setting cardHovered
  }

  nextImage(): void {
    if (!this.listing.images || this.listing.images.length <= 1) return;
    this.currentImageIndex = (this.currentImageIndex + 1) % this.listing.images.length;
  }

  prevImage(): void {
    if (!this.listing.images || this.listing.images.length <= 1) return;
    this.currentImageIndex = (this.currentImageIndex - 1 + this.listing.images.length) % this.listing.images.length;
  }

  setCurrentImage(index: number): void {
    if (index >= 0 && (!this.listing.images || index < this.listing.images.length)) {
      this.currentImageIndex = index;
    }
  }
}
